import { render, staticRenderFns } from "./PdfDefault.vue?vue&type=template&id=3fb4cffb&"
import script from "./PdfDefault.vue?vue&type=script&lang=js&"
export * from "./PdfDefault.vue?vue&type=script&lang=js&"
import style0 from "./PdfDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports